var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffenderError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14608",
    "data-name": "Group 14608",
    transform: "translate(-403 -355)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4041",
    "data-name": "Ellipse 4041",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(403 355)",
    fill: "#ff4d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6813",
    "data-name": "Path 6813",
    d: "M3845.7,2897.248l-.078,0a1.559,1.559,0,0,1-1.127-.569l-3.467-4.236a1.557,1.557,0,1,1,2.409-1.972l2.379,2.906,8.492-8.482a1.556,1.556,0,1,1,2.2,2.2l-9.708,9.7A1.557,1.557,0,0,1,3845.7,2897.248Z",
    transform: "translate(-3427.674 -2517.438)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffenderError);
export default __webpack_public_path__ + "static/media/offenderError.4e7220fb7f318f9b7a991daf7383ede8.svg";
export { ForwardRef as ReactComponent };